import { createSelector } from "reselect";
import { BOOK_TYPE } from "../../utils/content/content.constants";
import { KEY_REDUCER_MAIN_TREE } from "./constants";

const _selectorReducer = (state) => state[KEY_REDUCER_MAIN_TREE];

export const selectorMainTreeBibleVersions = (state) => _selectorReducer(state).bibles;
export const selectorMainTree = (state) => _selectorReducer(state).mainTree;
export const selectorMainTreeBooks = (state) => _selectorReducer(state).books;
export const selectorMainTreeIdsBooksFetchFailed = (state) => {
  return _selectorReducer(state).idsBooksFetchFailed;
};
export const selectorMainTreeSgBooksMap = (state) => _selectorReducer(state).sgBooksMap;
export const selectorMainTreeLangMap = (state) => _selectorReducer(state).langMap;
export const selectorMainTreeDictionaries = (state) => _selectorReducer(state).dictionaries;

export const selectorMainTreeBookLangMap = (state) => _selectorReducer(state).bookLangMap;

export const selectorMainTreeBooksPeriodicals = createSelector(
  selectorMainTreeBooks,
  (books) => {
    return books.filter((b) => b.type === BOOK_TYPE.periodical);
  },
);
